export const RemoveStatus = (statusCode = '') => ({
  type: 'INITIAL_STATE',
  payload: { statusCode },
});

export const RemoveSignatureStatus = (statusCode = '') => ({
  type: 'SIGNATURE_INITIAL_STATE',
  payload: { statusCode },
});

export const RejectApiStatus = (responseData) => ({
  type: 'API_REJECTED',
  payload: responseData,
});

export default { RemoveStatus, RemoveSignatureStatus };

export const ClearValidationErrors = () => ({
  type: 'CLEAR_VALIDATION_ERRORS',
  payload: {},
});
